<script>
    /*
    	ApiArrayFieldEditor.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components
    import ApiArrayChip from './ApiArrayChip.svelte';

    // SMUI components
    import Dialog, { Title, Content, Actions } from '@smui/dialog';
    import Button, { Label } from '@smui/button';
    import List, { Item, Meta, Separator, Text } from '@smui/list';
    import Checkbox from '@smui/checkbox';
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiPlusBox } from '@mdi/js';
    import AutoComplete from "simple-svelte-autocomplete"

    const BG_PATH = 'img/tcare_symbol.png';
    
    export let value;                       // the source array
    export let store;
    export let choices;
    export let propName;
    export let onHideEditor;
    export let label;
    export let isUserInput;                 // pass-through from ApiArrayField
    export let isUserSelect;                // pass-through from ApiArrayField

    $: newItem = '';
    $: selItem = null;                      // the one selected in the AutoComplete

    onMount(() => {
        // console.log('');
        // console.log('ApiArrayFieldEditor onMount');
        // console.log('value:');
        // console.log(value);
        if (value) {};              // suppress warning
    })

    // user can hit 'Enter' as well as click Add icon
    const _onInputKeyUp = (e) => {
        if (e.key !== 'Enter') return;
        _onAddNewItem();
    }

    const _onAddNewItem = () => {
        if (newItem === '') return;
        if (!$store) return;
        if (!$store.apiData) return;
        // create array if still null - arrgghhh
        if (!$store.apiData[propName]) $store.apiData[propName] = [];
        if ($store.apiData[propName].includes(newItem)) return;
        $store.apiData[propName].push(newItem);
        $store = $store;
        newItem = '';               // bound to UI input
    }

    const _onAddSelItem = () => {
        if (selItem === null) return;
        if (!$store) return;
        if (!$store.apiData) return;
        // create array if still null - arrgghhh
        if (!$store.apiData[propName]) $store.apiData[propName] = [];
        if ($store.apiData[propName].includes(selItem)) return;
        $store.apiData[propName].push(selItem);
        $store = $store;
        selItem = null;             // bound to UI AutoComplete
    }

    const onChipClick = (item) => {
        removeChipFromStore(item);
    }
    
    const removeChipFromStore = (item) => {
        const values = $store.apiData[propName];
        const idx = values.indexOf(item);
        if (idx > -1) {
            values.splice(idx, 1);
            $store = $store;
        }
    }
    
</script>



<style>

    .popup-title-row {
        padding: 15px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: var(--tcare-aqua);
    }

    .popup-title-icon {
        width: 30px;
        height: 24px;
    }

    .popup-title-icon img {
        width: 100%;
        height: 100%;
    }

    .popup-title-name {
        margin-left: 10px;
        font-size: 1.5em;
        font-weight: normal;
        color: var(--tcare-primary);
    }


    .padded-content {
        padding: 15px;
    }

    
    :global(.api-array-editor .mdc-dialog .mdc-dialog__surface) {
        width: 600px;
        max-width: 600px;
        border-radius: 18px;
    }

    /* plus sign for adding items */
	:global(.api-array-editor svg) {
		width: 36px !important;
		height: 36px !important;
		fill: var(--tcare-primary);
		outline: none;
	}

    .api-array-editor .input-row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* border: 1px solid red; */
    }

    .input-wrapper {
        width: 90%;
    }

    .input-wrapper input {
        width: 98%;            /* of the value container */
        min-height: 1.5em;
        padding: 5px;
        font-size: 1em;
        color: var(--tcare-field-value);
        border: 1px solid var(--tcare-primary);
        border-radius: 4px;
    }

    .api-array-editor .auto-complete-row {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        /* border: 1px solid green; */
    }

    :global(.auto-complete) {
        width: 90%;
        height: 100%;
    }

    :global(.auto-complete input) {
        width: 100%;
        height: 100%;
        border: 1px solid var(--tcare-primary);
        border-radius: 4px;
    }

    .api-array-editor .chips-row {
        width: 100%;
    }

    .api-array-editor .chips-box {
        width: 100%;
        min-height: 30px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        /* overflow-y: scroll; */
        /* border: 1px solid gray;         */
    }

    .api-array-editor .button-row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    :global(.api-array-editor .mdc-button) {
        min-width: 120px !important;
        margin-right: 4px !important;
        overflow: hidden;
    }


    
    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="api-array-editor">
    <Dialog open={true} scrimClickAction="" escapeKeyAction="">
        <div class="popup-title-row">
            <div class="popup-title-icon"><img src={BG_PATH} alt={'TCARE Symbol'}></div>
            <div class="popup-title-name">Edit {label}</div>
        </div>

        <div class="padded-content">

            {#if isUserInput}
                <div class="input-row">
                    <div class="input-wrapper">
                        <input bind:value={newItem} 
                            placeholder={'Enter your own value'}
                            on:keyup={_onInputKeyUp}
                        >
                    </div>
                    <Icon component={Svg} viewBox="0 0 24 24" on:click={() => _onAddNewItem()} >
                        <path d={mdiPlusBox} />
                    </Icon>
                </div>
            {/if}

            <div class="spacer-h-20"></div>

            {#if isUserSelect}
                <div class="auto-complete-row" >
                    <AutoComplete
                        className='auto-complete'
                        items={choices}
                        bind:selectedItem={selItem}
                        placeholder={'Select from saved values'}
                        maxItemsToShowInList=8
                        showClear
                        hideArrow
                        tabindex={-1}
                        closeOnBlur={false}
                        noResultsText={''}
                        create={false}
                        createText={''}
                    />                            
                    <Icon component={Svg} viewBox="0 0 24 24" on:click={() => _onAddSelItem()} >
                        <path d={mdiPlusBox} />
                    </Icon>
                </div>
            {/if}

            <div class="spacer-h-20"></div>
            
            <div class="chips-row">
                <div class="chips-box">
                    {#if $store.apiData[propName]}
                        {#each $store.apiData[propName] as item}
                            <ApiArrayChip {item} onChipClick={() => onChipClick(item)} />                        
                        {/each}
                    {/if}
                </div>
            </div>

            <div class="spacer-h-10"></div>

            <div class="button-row">
                <Button variant="raised" on:click={() => onHideEditor()} >
                    <Label>Close</Label>
                </Button>
            </div>

        </div>
    </Dialog>
</div>

